import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'
import { toRGBA } from '../../utils'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import styles from './ImageToCanvas.css'

// TODO: (3) Remove classnames
const cx = classNames.bind(styles)

/**
 * Loads an image and renders it into a canvas
 */
class ImageToCanvas extends PureComponent {
  state = {
    loaded: false,
  }

  onImageLoad() {
    const { width, height, theme, floorFade } = this.props
    const { dark } = theme.colors.greys
    const imageWidth = this.image.width
    const imageHeight = this.image.height
    const sourceRatio = imageWidth / imageHeight
    const targetRatio = width / height
    const ratioDiff = targetRatio / sourceRatio
    const ctx = this.canvas.getContext('2d')

    if (ratioDiff === 1) {
      ctx.drawImage(this.image, 0, 0, width, height)
      // Source wider than target
    } else if (ratioDiff < 1) {
      const w = imageWidth * ratioDiff
      const dx = (imageWidth - w) / 2
      ctx.drawImage(this.image, dx, 0, w, imageHeight, 0, 0, width, height)
      // Source more narrow than target
    } else {
      const h = imageHeight / ratioDiff
      const dy = (imageHeight - h) / 2
      ctx.drawImage(this.image, 0, dy, imageWidth, h, 0, 0, width, height)
    }

    if (floorFade) {
      var grV = ctx.createLinearGradient(0, 0, 0, height)
      const color = toRGBA(dark, 1, -1)
      grV.addColorStop(0.75, toRGBA(color, 0))
      grV.addColorStop(1, toRGBA(color, 0.8))

      ctx.fillStyle = grV
      ctx.fillRect(0, 0, width, height)
    }

    this.setState({ loaded: true })
  }

  render() {
    const { width, height, url, show, className } = this.props
    const { loaded } = this.state
    return (
      <div
        className={cx('Image', className, { Loading: !loaded })}
        style={{
          width,
          height,
        }}
      >
        {!loaded && show && (
          <img
            ref={ref => {
              this.image = ref
            }}
            className={styles.Source}
            src={url}
            draggable={false}
            alt={''}
            style={{ display: 'none' }}
            onLoad={this.onImageLoad.bind(this)}
          />
        )}
        <div className={styles.ImageBackground}>
          <canvas
            ref={ref => {
              this.canvas = ref
            }}
            className={cx('Canvas')}
            width={width}
            height={height}
            style={{ visibility: show ? 'visible' : 'hidden' }}
          />
        </div>
      </div>
    )
  }
}

ImageToCanvas.defaultProps = {
  width: 400,
  height: 400,
  show: true,
  floorFade: false,
}

ImageToCanvas.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  url: PropTypes.string.isRequired,
  show: PropTypes.bool,
  floorFade: PropTypes.bool,
}

export default withTheme(ImageToCanvas)
